import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Login from "../pages/Auth/Login";
import SignUp from "../pages/Auth/SignUp";
import About from "../pages/AboutUs";
import ForgetPassword from "../pages/Auth/ForgetPassword";
import Contact from "../pages/Contact";
import SubscriptionPlans from "../pages/SubscriptionPlans";
import ProfileFanPage from "../pages/ProfileFanPage";
import MusicFanPage from "../pages/MusicFanPage";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import CookiesPolicy from "../pages/CookiesPolicy";
import NotFoundPage from "../pages/404";
import TermsAndConditions from "../pages/TermsAndConditions";
import Cart from "../pages/Cart";
import SubscriptionSuccessful from "../pages/SubscriptionStatus";
import Layout from "../Layout";
const Router = () => {
  return (
    <>
      <Routes>
        <Route index element={<Layout>{<Home homeCSS={"bg-transparent absolute top-0 left-0 z-50"}/>}</Layout>} />
        <Route
          path="login"
          element={
            <Layout>
              <Login />
            </Layout>
          }
        />
        <Route
          path="/sign-up"
          element={
            <Layout>
              <SignUp />
            </Layout>
          }
        />
        <Route
          path="/about"
          element={
            <Layout>
              <About />
            </Layout>
          }
        />
        <Route
          path="/fanpage/:profileName"
          element={
            <Layout>
              <ProfileFanPage />
            </Layout>
          }
        />
        <Route
          path="/fanpage/:user/:title"
          element={
            <Layout>
              <MusicFanPage />
            </Layout>
          }
        />
        <Route
          path="/plans"
          element={
            <Layout>
              <SubscriptionPlans />
            </Layout>
          }
        />
        <Route
          path="/checkout"
          element={
            <Layout>
              <Cart />
            </Layout>
          }
        />
        <Route
          path="/subscription-success"
          element={
            <Layout>
              <SubscriptionSuccessful/>
            </Layout>
          }
        />
        <Route
          path="forget-password"
          element={
            <Layout>
              <ForgetPassword />{" "}
            </Layout>
          }
        />
        <Route
          path="contact"
          element={
            <Layout>
              <Contact />{" "}
            </Layout>
          }
        />
        <Route
          path="privacy-policy"
          element={
            <Layout>
              <PrivacyPolicy />{" "}
            </Layout>
          }
        />
        <Route
          path="terms-conditions"
          element={
            <Layout>
              <TermsAndConditions />{" "}
            </Layout>
          }
        />
        <Route
          path="cookies-policy"
          element={
            <Layout>
              <CookiesPolicy />{" "}
            </Layout>
          }
        />
        <Route path="*" Component={NotFoundPage} />
      </Routes>

      <Routes></Routes>
    </>
  );
};
//   <Route
//           path="/admin/*"
//           element={<ProtectedRoute Component={AdminDashboard} role="admin" />}
//         />
export default Router;
